import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface PasswordDTO {
  password: string;
}

export class Password {
  readonly isPasswordPassword: boolean = true;

  readonly password: string;

  static readonly constraints = {
    "password": {
      "minSize": 8,
      "maxSize": 128,
      
      
      
      
    }
  }

  constructor(
  password: string
  ) {
    Password.validatePassword(password);
    this.password = password;
  }

  static fromDTO(dto: PasswordDTO): Password {
    const password = getString(dto, "password", InvalidPasswordPasswordError);
    return new Password(
      password
    );
  }

  toDTO(): PasswordDTO {
    const dto: PasswordDTO = {
        password: this.password
    };
    return dto;
  }
  private static validatePassword = (password: string): void => {
    if(password.length < 8) {
      throw new InvalidPasswordPasswordMinSizeError(
        8,
        `Attribute password is too short. Size is ${password.length}. Min size is 8.`
      );
    }
    if(password.length > 128) {
      throw new InvalidPasswordPasswordMaxSizeError(
        128,
        `Attribute password is too long. Size is ${password.length}. Max size is 128.`
      );
    }
      if(password.trim().length === 0) {
        throw new InvalidPasswordPasswordNonEmptyError(
          `Attribute password cannot be an empty string.`
        );
      }
  }
  
}

Password.prototype.toString = function toString(): string {
  return `Password(password='${this.password}')`;
};

export class InvalidPasswordError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPasswordError";
  }
}
export class InvalidPasswordPasswordError extends InvalidPasswordError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPasswordPasswordError";
  }
}

export class InvalidPasswordPasswordMaxSizeError extends InvalidPasswordPasswordError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPasswordPasswordMaxSizeError";
  }
}

export class InvalidPasswordPasswordMinSizeError extends InvalidPasswordPasswordError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPasswordPasswordMinSizeError";
  }
}

export class InvalidPasswordPasswordNonEmptyError extends InvalidPasswordPasswordError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPasswordPasswordNonEmptyError";
  }
}
